import { Row, TableCell, Text } from "@amzn/meridian";
import React from "react";
import Textarea from "@amzn/meridian/textarea";
import { setFieldAdditionalInput } from "src/store/modelLifeCycleGroundTruthSlice";
import { useAppDispatch, useAppSelector } from "src/store/store";

export interface AdditionalInputConfig {
  label: string;
  placeholder: string;
}

interface AdditionalInputsCellProps {
  index: number;
  inputConfigs: AdditionalInputConfig[];
}

const AdditionalInputsCell = ({ index, inputConfigs }: AdditionalInputsCellProps) => {
  const dispatch = useAppDispatch();
  const additionalInputs = useAppSelector(
    (state) => state.modelLifeCycleGroundTruthSlice.additionalInputsByField[index] || {},
  );

  return (
    <>
      <TableCell width={"1%"}></TableCell>
      <TableCell columnSpan={100}>
        {inputConfigs.map(({ label, placeholder }) => (
          <Row key={label} alignmentVertical="center" spacingInset="100" widths={["20%", "80%"]}>
            <Text type="b200">{`${label}:`}</Text>
            <Textarea
              placeholder={placeholder}
              value={additionalInputs[label] || ""}
              onChange={(v) =>
                dispatch(setFieldAdditionalInput({ fieldIndex: index, key: label, value: v }))
              }
              rows={1}
            />
          </Row>
        ))}
      </TableCell>
    </>
  );
};

export default AdditionalInputsCell;
